import { HttpEvent, HttpEventType } from "@angular/common/http";
import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatDialogConfig } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Toast, ToastrService } from "ngx-toastr";
import { DataService } from "src/app/Services/dataservice.service";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { GetContentService } from "src/app/Services/getcontent.service";
import { TitleandmetaserviceService } from "src/app/Services/titleandmetaservice.service";
import { prodcmsconfig, testcmsconfig } from "src/app/shared/cms/cmsconfig";
import { ContentQueryModel } from "src/app/shared/cms/contentquerymodel";
import { ContentTypes } from "src/app/shared/enums/content.types";
import { parseIframeEmbedCode } from "src/app/utils/embed.util";

interface BlogEmbedView {
  url: SafeResourceUrl;
}

@Component({
  selector: "app-blog",
  templateUrl: "./blog.component.html",
  styleUrls: ["./blog.component.scss"],
})
export class PreviewBlogComponent implements OnInit {
  loadMore: any;
  noResultReturned: any;
  blog: any;
  selectedBlogContent!: any;
  articalModel!: any;
  isLoading!: boolean;
  contentTitle: string;
  userData: any;
  isBlogOwner!: boolean;
  blogEmbed: BlogEmbedView | null = null;
  @ViewChild("confirmDialog") confirmDialog!: TemplateRef<any>;
  dialogRef!: MatDialogRef<any>;

  constructor(
    private activateRouter: ActivatedRoute,
    private getContentService: GetContentService,
    private titleandmetaserviceService: TitleandmetaserviceService,
    private route: Router,
    private flowService: FlowServiceService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private dataService: DataService,
    private sanitizer: DomSanitizer
  ) {}

  get displayTimestamp(): Date {
    const timestamp = new Date(this.selectedBlogContent.timestamp);
    const invalidDate = new Date("0001-01-01T00:00:00+00:00");

    if (timestamp.getTime() === invalidDate.getTime()) {
      return new Date(); // return today's date
    }

    return timestamp;
  }

  onScrollDown() {}
  ngOnInit(): void {
    // One-time refresh logic
    if (!localStorage.getItem("pageReloaded")) {
      localStorage.setItem("pageReloaded", "true");
      location.reload(); // Full browser reload
      return; // Prevent further execution after reload
    }

    // Clear the flag for future navigations
    localStorage.removeItem("pageReloaded");

    this.activateRouter.paramMap.subscribe((params) => {
      var title = params.get("title");
      this.titleandmetaserviceService.setTitle(title);
      this.selectedBlogContent = JSON.parse(
        localStorage.getItem("selectedBlogContent")
      );
      this.selectedBlogContent.hashtags = this.normalizeHashTags(
        this.selectedBlogContent?.hashtags
      );
      this.blogEmbed = this.resolveBlogEmbed(
        this.selectedBlogContent?.embedCode ||
          this.selectedBlogContent?.EmbedCode
      );
    });

    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.isBlogOwner =
      this.userData.partitionKey == this.selectedBlogContent.partitionKey;
    console.log(this.isBlogOwner);
  }

  private resolveBlogEmbed(embedCode?: string): BlogEmbedView | null {
    const parsed = parseIframeEmbedCode(embedCode);
    if (!parsed?.src) {
      return null;
    }

    return {
      url: this.sanitizer.bypassSecurityTrustResourceUrl(parsed.src),
    };
  }

  private normalizeHashTags(rawHashTags: any): string[] {
    if (!rawHashTags) {
      return [];
    }

    if (Array.isArray(rawHashTags)) {
      return rawHashTags
        .map((tag) => (tag ?? "").toString().trim())
        .filter((tag) => !!tag);
    }

    return rawHashTags
      .toString()
      .replace("Keywords: ", "")
      .split(",")
      .map((tag) => tag.trim())
      .filter((tag) => !!tag);
  }
  viewUserProfile(selectedUser) {
    if (this.userData != null) {
      if (
        this.userData.emailAddress === selectedUser.partitionKey ||
        this.userData.emailAddress === selectedUser.partitionKey
      ) {
        this.route.navigate(["/user-profile"]);
      } else {
        this.route.navigate(["/view-profile"]);
      }
      this.dataService.flowByCategorieschangeMessage(selectedUser);
    } else {
      // this.dataService.flowByCategorieschangeMessage(selectedFlow);
      localStorage.setItem("returnUrl", this.route.url);
      this.route.navigate(["/registration"]);
    }
  }

  createTitleFromUrl(url: string) {
    // Replace hyphens with spaces and capitalize each word
    return url.replace(/-/g, " "); //.replace(/(?:^|\s)\S/g, (match) => match.toUpperCase());
  }

  onRightClick($event: any) {}
  goToAuthorsBlogs(userEmail: string, userName?: string) {
    localStorage.setItem("SelectedUserEmail", userEmail);
    if (userName) {
      localStorage.setItem("SelectedUserName", userName);
    }
    this.route.navigateByUrl("/bulbguide");
  }
  loadMoreblogs() {}

  async getBlogDetails(title: any) {
    this.noResultReturned = true;
    var contentQueryModel = new ContentQueryModel({
      applicationKey: testcmsconfig.applicationKey,
      environmentKey: testcmsconfig.environmentKey,
      contentType: ContentTypes.Blogs,
      contentTitle: title,
    });

    (
      await this.getContentService.getContentByContentTitleQueryModel(
        contentQueryModel
      )
    ).subscribe((data) => {
      this.selectedBlogContent = data;
      this.noResultReturned = false;
      this.articalModel = this.selectedBlogContent.articleModels[0];
      localStorage.removeItem("selectedBlogContent");
      localStorage.setItem(
        "selectedBlogContent",
        JSON.stringify(this.articalModel)
      );
      this.noResultReturned = false;
    });
  }

  onEdit() {
    console.log("Edit clicked!");
    if (this.selectedBlogContent) {
      this.route.navigateByUrl("/blog");
    }
    // Implement edit functionality here
  }

  onDelete() {
    this.dialogRef = this.dialog.open(this.confirmDialog, { width: "350px" });

    this.dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.selectedBlogContent.hashtags =
          this.selectedBlogContent.hashtags.join(", ");
        this.flowService
          .deleteBlog(this.selectedBlogContent)
          .subscribe((data) => {
            if (data) {
              this.toastr.success(
                `Blog: ${this.selectedBlogContent.title} deleted successfully!`
              );
              localStorage.setItem("selectedBlogContent", "null");
              this.route.navigateByUrl("/bulbguide");
            } else {
              this.toastr.error("Blog deletion failed. Please try again!");
            }
          });
      }
    });
  }
}
